export default __webpack_public_path__ + "static/media/btn-twitter.11f74631.png";